// Language Actions
export const LANGUAGE_CURRENT = 'language_current'